import {Presenter} from '../support/with_presenter';
import {Sprint} from '../../models/sprint';
import {SprintsRepository} from '../../persistence/sprints_repository';
import {Subscription} from 'rxjs';
import {AvailabilitiesRepository} from '../../persistence/availabilities_repository';
import {Availability} from '../../models/availability';

export class EmployeeRowPresenter implements Presenter {
    public sprints: Sprint[] | null = null;
    public availabilities: {[date: string]: Availability} = {};

    private sprintSubscription: Subscription | undefined;
    private availabilitiesSubscription: Subscription | undefined;

    constructor(
        private employeeId: number,
        private sprintsRepository: SprintsRepository,
        private availabilitiesRepository: AvailabilitiesRepository,
    ) {}

    public mount(): void {
        this.sprintSubscription = this.sprintsRepository
            .byEmployeeId(this.employeeId)
            .subscribe((sprints) => this.handleUpdateSprints(sprints));

        this.availabilitiesSubscription = this.availabilitiesRepository
            .findByEmployeeId(this.employeeId)
            .subscribe((availabilities) => this.handleUpdateAvailabilities(availabilities));
    }

    private handleUpdateAvailabilities(availabilities: {[date: string]: Availability}) {
        this.availabilities = availabilities || [];
    }

    private handleUpdateSprints(sprints: Sprint[]) {
        this.sprints = sprints;
    }

    public unmount(): void {
        if (this.sprintSubscription) {
            this.sprintSubscription.unsubscribe();
        }
        if (this.availabilitiesSubscription) {
            this.availabilitiesSubscription.unsubscribe();
        }
    }
}
